var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreifcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7485 16H1.2515C0.5615 16 0 15.4385 0 14.7485V3.7515C0 3.0615 0.5615 2.5 1.2515 2.5H14.7485C15.4385 2.5 16 3.0615 16 3.7515V14.7485C16 15.4385 15.4385 16 14.7485 16ZM1.2515 3.5C1.113 3.5 1 3.613 1 3.7515V14.7485C1 14.887 1.113 15 1.2515 15H14.7485C14.887 15 15 14.887 15 14.7485V3.7515C15 3.613 14.887 3.5 14.7485 3.5H1.2515Z",
    fill: "#3E3F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.5H0.5C0.224 11.5 0 11.2765 0 11C0 10.7235 0.224 10.5 0.5 10.5H15.5C15.7765 10.5 16 10.7235 16 11C16 11.2765 15.7765 11.5 15.5 11.5Z",
    fill: "#3E3F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H10V1.287C10 1.1255 9.899 1 9.8115 1H6.1885C6.0995 1 6 1.123 6 1.287V3H5V1.287C5 0.5775 5.533 0 6.1885 0H9.8115C10.467 0 11 0.5775 11 1.287V3Z",
    fill: "#3E3F42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.00001C7.87 9.00001 7.74 8.94501 7.645 8.85501C7.555 8.76001 7.5 8.63001 7.5 8.50001C7.5 8.37001 7.555 8.24001 7.645 8.14501C7.83 7.96001 8.165 7.96001 8.355 8.14501C8.445 8.24001 8.5 8.37001 8.5 8.50001C8.5 8.63001 8.445 8.76001 8.355 8.85501C8.26 8.94501 8.13 9.00001 8 9.00001Z",
    fill: "#3E3F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreifcase);
export default __webpack_public_path__ + "static/media/breifcase.bc2b62eab21a67e3a320089e25a89db7.svg";
export { ForwardRef as ReactComponent };